// SmoothScroll.js — Lenis smooth scroll, GSAP ticker integrated
//
// Mobile note: Lenis's touch handler competes with the react-three-fiber
// canvas inside GlobeSection3D on mobile — swiping past the globe used
// to get stuck. Skip Lenis entirely on narrow viewports; native mobile
// browsers already have smooth momentum scrolling built in.
import { useEffect } from 'react';
import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Match MUI's md breakpoint (900px) — mobile + small tablet skip Lenis.
const DESKTOP_MEDIA_QUERY = '(min-width: 900px)';

export default function SmoothScroll({ children }) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!window.matchMedia(DESKTOP_MEDIA_QUERY).matches) return;

    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 0.9,
      syncTouch: false,
      smoothTouch: false,
    });

    lenis.on('scroll', ScrollTrigger.update);

    const tick = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(tick);
    gsap.ticker.lagSmoothing(0);

    return () => {
      gsap.ticker.remove(tick);
      lenis.destroy();
    };
  }, []);

  return children;
}
